import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { Modal, Button, Form } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import "./Spinner.css";
import "./requestBodyEditor.css";

const fieldCategories = [
  {
    category: "Auth Fields",
    icon: "🔑",
    fields: [
      { label: "Username", key: "username", placeholder: "{username}" },
      { label: "Password", key: "password", placeholder: "{password}" },
      { label: "Token", key: "token", placeholder: "{token}" },
      { label: "Key", key: "key", placeholder: "{key}" },
      { label: "Value", key: "value", placeholder: "{value}" },
      { label: "Action", key: "action", placeholder: "{action}" },
    ],
  },
  {
    category: "Lab Fields",
    icon: "🧪",
    fields: [
      { label: "Client Id", key: "clientId", placeholder: "{client-code}" },
      { label: "Test Id", key: "testId", placeholder: "{testid}" },
      { label: "Lab Code", key: "labcode", placeholder: "{lab-code}" },
      { label: "Lab Name", key: "labname", placeholder: "{lab-name}" },
      { label: "Address", key: "address", placeholder: "{lab-address}" },
      { label: "Phone Number", key: "phone", placeholder: "{phone}" },
      { label: "Email Id", key: "email", placeholder: "{lab-email}" },
    ],
  },
  {
    category: "Employer Fields",
    icon: "🏢",
    fields: [
      { label: "Org Code", key: "companycode", placeholder: "{company-code}" },
      { label: "Name", key: "name", placeholder: "{name}" },
    ],
  },
  {
    category: "Employee Fields",
    icon: "👤",
    fields: [
      { label: "Salutation", key: "salutation", placeholder: "{salutation}" },
      { label: "First Name", key: "firstname", placeholder: "{firstname}" },
      { label: "Last Name", key: "lastname", placeholder: "{lastname}" },
      { label: "Date of Birth", key: "dob", placeholder: "{dob}" },
      { label: "Gender", key: "gender", placeholder: "{gender}" },
      { label: "Age YYY", key: "AgeYYY", placeholder: "{AgeYYY}" },
      { label: "Age MM", key: "AgeMM", placeholder: "{AgeMM}" },
      { label: "Age DD", key: "AgeDD", placeholder: "{AgeDD}" },
      { label: "Employee ID", key: "empid", placeholder: "{empid}" },
      { label: "Email", key: "email", placeholder: "{employee-email}" },
      { label: "Phone Number", key: "phoneno", placeholder: "{phoneno}" },
      { label: "Aadhar Number", key: "aadhaarnumber", placeholder: "{aadhaarnumber}" },
      { label: "PAN", key: "pan", placeholder: "{pan}" },
      { label: "Address", key: "address", placeholder: "{employee-address}" },
      { label: "Designation ID", key: "designationId", placeholder: "{designationId}" },
      { label: "Date of Joining", key: "dateOfJoining", placeholder: "{dateOfJoining}" },
      { label: "Height", key: "height", placeholder: "{height}" },
      { label: "Weight", key: "weight", placeholder: "{weight}" },
    ],
  },
  {
    category: "Appointment Fields",
    icon: "📅",
    fields: [
      { label: "Order Date", key: "orderDate", placeholder: "{currentdate}" },
      { label: "Appointment Date", key: "appointmentDate", placeholder: "{appointment-date}" },
      { label: "Order Id", key: "orderid", placeholder: "{orderid}" },
      { label: "Patient Reason Id", key: "pReasonId", placeholder: "{pReasonId}" },
      { label: "Group Id", key: "groupid", placeholder: "{groupid}" },
    ],
  },
  {
    category: "Location Fields",
    icon: "📍",
    fields: [
      { label: "Pincode", key: "pincode", placeholder: "{pincode}" },
      { label: "State Id", key: "stateId", placeholder: "{stateId}" },
      { label: "City Id", key: "cityId", placeholder: "{cityId}" },
      { label: "Service Code", key: "serviceCode", placeholder: "{serviceCode}" },
    ],
  },
  {
    category: "Lab Integration Fields",
    icon: "🔬",
    fields: [
      { label: "Integration Order ID", key: "integrationOrderId", placeholder: "{integrationOrderId}" },
      { label: "Integration Patient ID", key: "integrationPatientId", placeholder: "{integrationPatientId}" },
      { label: "Integration Branch Code", key: "integrationBranchCode", placeholder: "{integrationBranchCode}" },
      { label: "Integration Service Code", key: "integrationServiceCode", placeholder: "{integrationServiceCode}" },
      { label: "Service Name", key: "serviceName", placeholder: "{service-name}" },
      { label: "Area ID", key: "areaId", placeholder: "{areaId}" },
      { label: "Branch ID", key: "branchId", placeholder: "{branchId}" },
      { label: "City ID", key: "labIntegrationCityId", placeholder: "{cityId}" },
      { label: "Collection Date Time", key: "collectionDateTime", placeholder: "{collectionDateTime}" },
      { label: "Registration Date", key: "registrationDate", placeholder: "{registrationDate}" },
      { label: "Visit Booked By", key: "visitBookedBy", placeholder: "{visitBookedBy}" },
    ],
  },
];

const ViewOrUpdateApiBody = ({ isOpen, onRequestClose, apiId, apiName }) => {
  const navigate = useNavigate();
  const textareaRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [requestBody, setRequestBody] = useState("");
  const [bodyId, setBodyId] = useState(null);
  const [selectedField, setSelectedField] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [viewMode, setViewMode] = useState("chips"); // 'chips' or 'select'

  useEffect(() => {
    if (isOpen && apiId) {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem("data"))?.token;
      axios
        .get(`/api/lab-controller-apis/body/apiid=${apiId}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          setRequestBody(response.data?.requestBody || "");
          setBodyId(response.data?.id || null);
        })
        .catch((error) => {
          if (error.response?.status !== 404) {
            handleError(error);
          }
          setRequestBody("");
          setBodyId(null);
        })
        .finally(() => setLoading(false));
    }
  }, [isOpen, apiId]);

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred.");
      }
    } else {
      toast.error(error.message || "An error occurred.");
    }
  }

  function insertPlaceholder(placeholderText) {
    if (!placeholderText) return;
    const textarea = textareaRef.current;
    if (!textarea) return;

    const start = textarea.selectionStart || 0;
    const end = textarea.selectionEnd || 0;
    const newBody =
      requestBody.substring(0, start) + placeholderText + requestBody.substring(end);
    setRequestBody(newBody);

    setTimeout(() => {
      textarea.selectionStart = textarea.selectionEnd = start + placeholderText.length;
      textarea.focus();
    }, 0);
  }

  function handleDropdownSelect(e) {
    const value = e.target.value;
    setSelectedField(value);
    if (!value) return;

    // Find matching placeholder from categories
    for (const cat of fieldCategories) {
      const match = cat.fields.find((f) => f.key === value);
      if (match) {
        insertPlaceholder(match.placeholder);
        break;
      }
    }
    setTimeout(() => setSelectedField(""), 100);
  }

  function formatJSON() {
    if (!requestBody.trim()) return;
    try {
      const parsed = JSON.parse(requestBody);
      setRequestBody(JSON.stringify(parsed, null, 2));
      toast.success("JSON formatted successfully!");
    } catch (err) {
      toast.warn("Invalid JSON format. Placeholders or syntax prevented auto-format.");
    }
  }

  function copyToClipboard() {
    if (!requestBody) return;
    navigator.clipboard.writeText(requestBody);
    toast.info("Copied request body to clipboard!");
  }

  function clearBody() {
    if (window.confirm("Are you sure you want to clear the request body?")) {
      setRequestBody("");
    }
  }

  function saveBody() {
    const token = JSON.parse(localStorage.getItem("data"))?.token;
    setLoading(true);

    const payload = {
      labControllerApiId: apiId,
      requestBody: requestBody,
    };
    if (bodyId) payload.id = bodyId;

    axios
      .post(`/api/lab-controller-apis/body/saveOrUpdate`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setBodyId(response.data?.id || bodyId);
        toast.success("Body saved successfully!");
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error);
      });
  }

  // Filter fields based on category and search query
  const getFilteredFields = () => {
    let list = [];
    fieldCategories.forEach((cat) => {
      if (selectedCategory === "All" || selectedCategory === cat.category) {
        cat.fields.forEach((field) => {
          if (
            !searchQuery ||
            field.label.toLowerCase().includes(searchQuery.toLowerCase()) ||
            field.placeholder.toLowerCase().includes(searchQuery.toLowerCase())
          ) {
            list.push({ ...field, category: cat.category, icon: cat.icon });
          }
        });
      }
    });
    return list;
  };

  const filteredFieldsList = getFilteredFields();

  return (
    <Modal
      show={isOpen}
      onHide={onRequestClose}
      centered
      size="xl"
      dialogClassName="request-body-modal"
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title>
          <span className="text-white fw-bold">⚡ View / Update Body</span>
          {apiName && (
            <span className="badge bg-info bg-gradient text-white rounded-pill fs-7 fw-normal ms-2">
              {apiName}
            </span>
          )}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}

        {/* Placeholders palette / Dropdown selector */}
        <div className="placeholder-palette-card">
          <div className="placeholder-header">
            <div className="placeholder-title">
              <span>📌 Field Placeholders</span>
              <span className="badge bg-secondary text-dark bg-opacity-10 rounded-pill ms-1 fs-8">
                Click to insert at cursor
              </span>
            </div>

            <div className="d-flex align-items-center gap-2">
              <input
                type="text"
                className="placeholder-search-input"
                placeholder="🔍 Search fields..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <button
                className="btn btn-sm btn-outline-secondary rounded-2 py-1 px-2 fs-8"
                onClick={() => setViewMode(viewMode === "chips" ? "select" : "chips")}
                title="Toggle view mode"
              >
                {viewMode === "chips" ? "Dropdown View" : "Chip View"}
              </button>
            </div>
          </div>

          {viewMode === "chips" ? (
            <>
              {/* Category Pills */}
              <div className="category-pills-nav">
                <button
                  className={`category-pill-btn ${selectedCategory === "All" ? "active" : ""}`}
                  onClick={() => setSelectedCategory("All")}
                >
                  All Fields
                </button>
                {fieldCategories.map((cat) => (
                  <button
                    key={cat.category}
                    className={`category-pill-btn ${selectedCategory === cat.category ? "active" : ""
                      }`}
                    onClick={() => setSelectedCategory(cat.category)}
                  >
                    {cat.icon} {cat.category}
                  </button>
                ))}
              </div>

              {/* Chips container */}
              <div className="placeholder-chips-container">
                {filteredFieldsList.length > 0 ? (
                  filteredFieldsList.map((item) => (
                    <button
                      key={item.key}
                      type="button"
                      className="placeholder-chip"
                      onClick={() => insertPlaceholder(item.placeholder)}
                      title={`Insert ${item.placeholder}`}
                    >
                      <span>{item.label}</span>
                      <span className="chip-tag">{item.placeholder}</span>
                    </button>
                  ))
                ) : (
                  <div className="text-muted fs-8 py-2">
                    No placeholders matching "{searchQuery}"
                  </div>
                )}
              </div>
            </>
          ) : (
            /* Fallback Dropdown view */
            <select
              className="form-select modern-select"
              value={selectedField}
              onChange={handleDropdownSelect}
            >
              <option value="">-- Select a field to insert --</option>
              {fieldCategories.map((cat) => (
                <optgroup key={cat.category} label={`${cat.icon} ${cat.category}`}>
                  {cat.fields.map((f) => (
                    <option key={f.key} value={f.key}>
                      {f.label} ({f.placeholder})
                    </option>
                  ))}
                </optgroup>
              ))}
            </select>
          )}
        </div>

        {/* Code Editor Container */}
        <div className="editor-wrapper">
          <div className="editor-toolbar">
            <div className="editor-title">
              <span>💻 Request Body (JSON / Template)</span>
            </div>
            <div className="editor-actions">
              <button
                type="button"
                className="editor-btn"
                onClick={formatJSON}
                title="Format JSON"
              >
                ⚡ Format
              </button>
              <button
                type="button"
                className="editor-btn"
                onClick={copyToClipboard}
                title="Copy body to clipboard"
              >
                📋 Copy
              </button>
              <button
                type="button"
                className="editor-btn"
                onClick={clearBody}
                title="Clear text"
              >
                🧹 Clear
              </button>
            </div>
          </div>
          <textarea
            ref={textareaRef}
            className="editor-textarea"
            rows="16"
            value={requestBody}
            onChange={(e) => setRequestBody(e.target.value)}
            placeholder={`{\n  "username": "{username}",\n  "pincode": "{pincode}",\n  "currentDate": "{currentdate}"\n}`}
          />
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button
          type="button"
          className="btn btn-gradient-primary"
          onClick={saveBody}
          disabled={loading}
        >
          {loading ? "Saving..." : "Save Body"}
        </button>
        <button
          type="button"
          className="btn btn-secondary-modern"
          onClick={onRequestClose}
        >
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewOrUpdateApiBody;
